import React from 'react'

interface HandlePageWelcome {
  page : Number,
  setPage : Function
}
const HandlePageWelcome = React.createContext<HandlePageWelcome | null>(null);


export {HandlePageWelcome}